/* eslint-disable react/button-has-type */
import React from "react";
import PropTypes from "prop-types";

// components
import { AppContext } from "components";
import { BaseComponent } from "shared/components";

import {
    CutSelect,
    AttributeSelect,
    TagsSelect, DetailsSelect,
    ImagesUpload
} from "components/ProductComponents";

import PictureCardComponent from "./PictureCardComponent";

class AddPicturesComponent extends BaseComponent {
    constructor(props) {
        super(props);

        this.imagesUploadRef = React.createRef();

        this.state = {
            pictures: [],
            newPicture: {},
            cuts: [],
            details: [],
            attributes: [],
            tags: [],
            picture: [],
            image: [],
            loading: false,
        };

        this.onChange = this.onChange.bind(this);
        this.onChangeImage = this.onChangeImage.bind(this);
        this.setNewPicture = this.setNewPicture.bind(this);
        this.resetState = this.resetState.bind(this);
        this.renderCards = this.renderCards.bind(this);
    }

    async setNewPicture() {
        const {
            newPicture,
            attributes,
            cuts,
            tags,
            details,
            picture,
            pictures,
        } = this.state;

        const valid = await this.hasProperties({
            cuts,
            attributes,
            tags,
            details,
            picture,
        });
        if (!valid) { return };
        newPicture.attributes = attributes;
        newPicture.cuts = cuts;
        newPicture.tags = tags;
        newPicture.details = details;
        newPicture.image = picture[0];
        pictures.push(newPicture);
        this.resetState();
        this.setState({ pictures });
    }

    getPictures() {
        return this.state.pictures;
    }

    reloadRef() {
        this.setState({ pictures: [] });
    }

    resetState() {
        this.imagesUploadRef.current.resetState();
        this.setState({
            cuts: [],
            attributes: [],
            tags: [],
            details: [],
            picture: [],
            newPicture: {},
        });
    }

    onChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    onChangeImage(images) {
        this.setState({
            picture: images.file,
        });
    }

    hasProperties(property) {
        let valid = true;
        for (const [key, value] of Object.entries(property)) {
            if (value.length === 0) {
                this.showErrorToast(`Please select ${key}.`);
                valid = false;
                return valid;
            }
        }
        return valid;
    }

    delete(name) {
        const newPictures = this.state.pictures.filter(
            (p) => p.image.name !== name
        );

        this.setState({ pictures: newPictures });
    }

    renderCards(pictures) {
        if (pictures.lenght === 0) {
            return null;
        }

        return (
            <div className="columns is-multiline is-mobile">
                {pictures.map((picture) => (
                    <div className="column is-one-quarter">
                        <PictureCardComponent
                            key={pictures.indexOf(picture)}
                            image={picture.image.preview}
                            value={picture.image}
                            removeProduct={this.delete.bind(this)}
                        />
                    </div>
                ))}
            </div>
        );
    }

    render() {
        const { newPicture, cuts, attributes, tags, pictures, details } = this.state;
        return (
            <div className="container">
                <div className="columns is-mobile is-multiline mx-6 px-6">
                    <div className="column is-half">
                        <CutSelect name="cuts" id="cut-select" value={cuts} label="Cuts" onChange={this.onChange} />
                    </div>
                    <div className="column is-half">
                        <AttributeSelect name="attributes" value={attributes} label="Attributes" id="attribute-select" onChange={this.onChange} />
                    </div>
                    <div className="column is-half">
                        <TagsSelect name="tags" id="tag-select" value={tags} placeholder="Tags" label="Tags" onChange={this.onChange} />
                    </div>
                    <div className="column is-half">
                        <DetailsSelect name="details" id="detail-select" value={details} placeholder="Details" label="Details" onChange={this.onChange} />
                    </div>
                    <div className="column is-full">
                        <ImagesUpload
                            ref={this.imagesUploadRef} size="is-small" placeholder="Picture"
                            onChange={this.onChangeImage} value={pictures}
                        />
                    </div>
                    <div className="column is-full">
                        <button
                            className="button is-fullwidth is-info"
                            onKeyPress={this.searchInputKeyPressed}
                            onClick={this.setNewPicture}
                        >
                            <span className="icon is-small" value={newPicture} id="new-picture">
                                <i className="fas fa-user-plus" />
                            </span>
                        </button>
                    </div>
                </div>
                {this.renderCards(pictures)}
            </div>
        );
    }
}

AddPicturesComponent.contextType = AppContext;

AddPicturesComponent.propTypes = {
    product: PropTypes.object,
};

export default AddPicturesComponent;
